import {Component, forwardRef, Input, OnInit, SimpleChanges,OnChanges} from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators, FormGroup, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {compareMatch, SubdivisionIndustrySelectionValue, GetIndustryClassesByGroupCodeFn, IndustryClass} from '@portal-workspace/grow-shared-library';
 
import {UntilDestroy} from '@ngneat/until-destroy';
import {formControlErrorKeys, formControlErrorMessage, setupUntilDestroy,PortalHotToastService} from '@portal-workspace/grow-ui-library';
import {Subscription, of} from 'rxjs';
import {distinctUntilChanged, tap,catchError} from 'rxjs/operators';
import {AbstractControlValueAccessor} from '../abstract-control-value-accessor';
import {MARK, Mark} from '@portal-workspace/grow-ui-library/mark';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';


@UntilDestroy()
@Component({
    selector: 'subdivision-industry-selection',
    templateUrl: './subdivision-industry-selection.component.html',
    styleUrls: ['./subdivision-industry-selection.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SubdivisionIndustrySelectionComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => SubdivisionIndustrySelectionComponent) },
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule]
})
export class SubdivisionIndustrySelectionComponent extends AbstractControlValueAccessor<SubdivisionIndustrySelectionValue> implements OnInit, OnChanges,Mark {

  formGroup: FormGroup<{
    selection: FormControl<SubdivisionIndustrySelectionValue>;
  }>;
  formControl: FormControl<SubdivisionIndustrySelectionValue>;

  subscription?: Subscription;
  formControlSubscription: Subscription;
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;

  subdivisionIndustries: IndustryClass[] = [];
  @Input({required: true}) groupCode: string | null = null;
  @Input({required: true}) getIndustryClassesByGroupCodeFn!: GetIndustryClassesByGroupCodeFn | null;
  
  compareWithFn: (option: SubdivisionIndustrySelectionValue, selected: SubdivisionIndustrySelectionValue) => boolean = (option, selected) => {
    return (!!option && !!selected && option.code === selected.code);
  };


  constructor(private formBuilder: FormBuilder,
              private toastService: PortalHotToastService) {
    super();
    this.formControl = formBuilder.control(null, [Validators.required]);
    this.formGroup = formBuilder.group({
      selection: this.formControl,
    });
    this.formControlSubscription = this.formControl.valueChanges.pipe(
      distinctUntilChanged(compareMatch),
      tap(r => {
        this.propagateChange(r);
      })
    ).subscribe();
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
    if (this.groupCode && this.getIndustryClassesByGroupCodeFn) {
      this.loadSubdivisionIndustries(this.groupCode);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['groupCode']) {
      const newGroupCode = changes['groupCode'].currentValue;
      const previousGroupCode = changes['groupCode'].previousValue;
      if (newGroupCode && newGroupCode !== previousGroupCode) {
        this.formControl.setValue(null);
        this.subdivisionIndustries = [];
        if (this.getIndustryClassesByGroupCodeFn) {
          this.loadSubdivisionIndustries(newGroupCode);
        }
      }else if (!newGroupCode) {
        this.formControl.setValue(null);
        this.subdivisionIndustries = [];
      }
    }
  }

  private loadSubdivisionIndustries(groupCode: string): void {
    if(this.getIndustryClassesByGroupCodeFn) {
    this.getIndustryClassesByGroupCodeFn(groupCode).pipe(
      this.toastService.spinnerObservable(),
       tap((industryClasses: IndustryClass[]) => {
        this.subdivisionIndustries = industryClasses;
       }),
      catchError(err => {
        this.toastService.error('Failed to load subdivision industries', 'Error');
        this.subdivisionIndustries = [];
        return of([]);
      })
    ).subscribe();
    }
  }

  doWriteValue(v: SubdivisionIndustrySelectionValue | null): void | SubdivisionIndustrySelectionValue {
    if (v) {
      const o = this.subdivisionIndustries.find(opt => opt.code === v.code);
      if (o) {
        this.formControl.setValue(o);
        return o;
      }else {
        this.formControl.setValue(v);
        return v;
      }
    }
    return undefined;
  }
  mark() {
    this.formGroup.markAllAsTouched();
  }
}
